export default __webpack_public_path__ + "static/media/53t.163420b5.jpg";